module.exports = __webpack_public_path__ + "static/media/bg_missao.27f17b1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/bg_missao.png
// module id = 1212
// module chunks = 0